import { VideoselfingApi } from './services/videoselfing-api.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { LandingVideoselfingComponent } from './landing-videoselfing.component';

const routes: Routes = [
  { path: 'landing-videoselfing/:code', component: LandingVideoselfingComponent },
  { path: 'landing-videoselfing', component: LandingVideoselfingComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [VideoselfingApi],
})
export class LandingVideoselfingRoutingModule {}
